import { fields, createSchema, validate as _validate } from '..';

const { requiredArrayOfStrings } = fields;

const schema = createSchema({
  personalGoals: requiredArrayOfStrings,
});

const validate = (data) => {
  return _validate(schema, data);
};

export default validate;
